var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStageAnomaly = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "stage-anomaly__a",
    d: "M13.446.106c.193.097.35.253.447.447L25.89 24.55c.247.494.047 1.095-.447 1.342-.139.07-.292.106-.447.106H1c-.552 0-1-.448-1-1 0-.156.036-.309.106-.448L12.104.553c.247-.494.848-.694 1.342-.447zm.375 18.144h-1.645l-.101.01c-.196.04-.35.189-.39.379l-.01.098v1.6l.01.098c.04.19.194.34.39.38l.1.009h1.646l.1-.01c.196-.039.35-.189.39-.379l.01-.098v-1.6l-.01-.098c-.04-.19-.194-.34-.39-.379l-.1-.01zm0-8.8h-1.645l-.101.012c-.196.048-.35.23-.39.463l-.01.12v6.67l.01.12c.04.232.194.415.39.463l.1.012h1.646l.1-.012c.196-.048.35-.23.39-.463l.01-.12v-6.67l-.01-.12c-.04-.232-.194-.415-.39-.463l-.1-.012z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(.002 .002)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "stage-anomaly__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stage-anomaly__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stage-anomaly__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25.997V26H0z",
    mask: "url(#stage-anomaly__b)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStageAnomaly);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stage-anomaly.0a7af4ea350ff8c6c71389a6b865d075.svg";